
  import { Component, Vue } from 'vue-property-decorator';
  import { mapGetters } from 'vuex';

  import Input from '@/components/Core/Input.vue';

  import { IErrorModel } from '@/models/errors.model';
  import { IPasswordRecoveryResetModel } from '@/models/recovery.model';

  import accountService from '@/services/account.service';
  import routeService from '@/services/route.service';

  @Component({
    components: {
      Input
    },
    computed: {
      ...mapGetters([
        'isLoading'
      ])
    }
  })
  export default class PasswordRecoveryReset extends Vue {
    data() {
      return {
        studio: '',
        hasErrors: false,
        isResetLoading: false,
        errors: new Array<IErrorModel>(),
        hasPasswordErrors: false,
        passwordErrors: new Array<IErrorModel>(),
        hasConfirmPasswordErrors: false,
        confirmPasswordErrors: new Array<IErrorModel>(),
        form: {} as IPasswordRecoveryResetModel
      }
    };

    created() {
      this.$data.studio = this.$data.RCEnvironment.VUE_APP_PARTNER_NAME;
      this.$data.form.Token = this.$route.query.token;
    }

    resetPassword() {
      if (this.$data.isResetLoading) {
        return;
      }

      this.$store.dispatch("updateIsLoading", true);
      this.$data.isResetLoading = true;
      this.resetErrors();

      setTimeout(() => {
        const url: string = this.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "password/password-recovery-validation";

        accountService.post<IPasswordRecoveryResetModel, object>(this, url, this.$data.form)
          .then(() => {
            this.$store.dispatch("updateIsLoading", false);
            this.$data.isResetLoading = false;
            routeService.redirectToLogin(this);
          })
          .catch(errors => {
            const dataErrors = errors.data.ErrorMessages as Array<IErrorModel>;

            this.$data.errors = dataErrors.filter(error => error.Property == '');
            this.$data.passwordErrors = dataErrors.filter(error => error.Property == 'Password');
            this.$data.confirmPasswordErrors = dataErrors.filter(error => error.Property == 'ConfirmPassword');

            this.$data.hasErrors = this.$data.errors.length;
            this.$data.hasPasswordErrors = this.$data.passwordErrors.length;
            this.$data.hasConfirmPasswordErrors = this.$data.confirmPasswordErrors.length;

            this.$data.isResetLoading = false;
            this.$store.dispatch("updateIsLoading", false);
          });
      }, 300);
    }

    private resetErrors() {
      this.$data.hasErrors = false;
      this.$data.hasPasswordErrors = false;
      this.$data.hasConfirmPasswordErrors = false;

      this.$data.errors = new Array<IErrorModel>();
      this.$data.passwordErrors = new Array<IErrorModel>();
      this.$data.confirmPasswordErrors = new Array<IErrorModel>();
    }

    updateFormValue(parameter: string, value: string) {
      this.$set(this.$data.form, parameter, value);
    }
  }
